import { alpha } from '@mui/material/styles';
import basicTheme from '../basicTheme.js';
import typography from '../typography.js';

/* eslint-disable @typescript-eslint/ban-ts-comment */
const tooltipStyleOverrides = {
    defaultProps: {
        placement: 'bottom',
        enterDelay: 3000,
        enterNextDelay: 3000,
        enterTouchDelay: 3000,
    },
    styleOverrides: {
        // @ts-ignore
        tooltip: Object.assign(Object.assign({ borderRadius: '2px', border: `1px solid ${basicTheme.palette.N30.main}`, backgroundColor: basicTheme.palette.N80.main, color: basicTheme.palette.N20.main }, typography.subtitle4), { lineHeight: '14px', maxWidth: '400px', textTransform: 'none', boxShadow: `0px 4px 4px ${alpha(basicTheme.palette.common.black, 0.25)}`, padding: basicTheme.spacing(0.75, 1.75) }),
        arrow: {
            color: basicTheme.palette.N80.main,
            '&:before': {
                border: `1px solid ${basicTheme.palette.N30.main}`,
            },
        },
        tooltipPlacementBottom: {
            margin: `${basicTheme.spacing(5, 0)} !important`,
            '.MuiTooltip-arrow': {
                width: '14px',
                height: '10px',
                margin: `${basicTheme.spacing('-1em', 0)} !important`,
                ':before': {
                    borderRadius: '2px 0',
                },
            },
        },
        tooltipPlacementTop: {
            margin: `${basicTheme.spacing(0, 0, 2, 0)} !important`,
            '.MuiTooltip-arrow': {
                width: '14px',
                height: '10px',
                margin: `${basicTheme.spacing('-1em', 0)} !important`,
                ':before': {
                    borderRadius: '2px 0',
                },
            },
        },
        tooltipPlacementLeft: {
            margin: `${basicTheme.spacing(0, 2)} !important`,
            '.MuiTooltip-arrow': {
                width: '10px !important',
                height: '14px !important',
                margin: `${basicTheme.spacing(0, '-1em')} !important`,
                ':before': {
                    borderRadius: '0 2px',
                },
            },
        },
        tooltipPlacementRight: {
            margin: `${basicTheme.spacing(0, 2)} !important`,
            '.MuiTooltip-arrow': {
                width: '10px !important',
                height: '14px !important',
                margin: `${basicTheme.spacing(0, '-1em')} !important`,
                ':before': {
                    borderRadius: '0 2px',
                },
            },
        },
    },
};

export { tooltipStyleOverrides as default };
//# sourceMappingURL=MuiTooltip.js.map
